import { React, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import "../css/EscortOfficerList.css";
import Modal from "../../../../../components/element/Modal";
import { ClearanceStatus, TRIP_PHASE } from "../../../../../utils/constants";
import AddOfficerModal from "../../../../../components/element/AddOfficerModal";
import DeleteModal from "../../../../../components/element/DeleteModal";
import deleteIcon from "../../../../../assets/images/delete_icon.svg";
import editIcon from "../../../../../assets/images/edit_icon.svg";

const EscortDepartureOfficersList = ({
  officers,
  onAddOfficer,
  onEditOfficer,
  onDeleteOfficer,
  clearanceStatus,
  airportId,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [officerToDelete, setOfficerToDelete] = useState(null);
  const [editingOfficer, setEditingOfficer] = useState(null);

  const handleAddOfficeClick = () => {
    setIsModalOpen(true);
  };

  const handleDeleteClick = (index) => {
    if (officers.length <= 2) {
      // Don't allow deletion if only 2 officers remain
      return;
    }
    setOfficerToDelete(index);
    setIsDeleteModalOpen(true);
  };
  const confirmDeleteOfficer = () => {
    if (officerToDelete !== null) {
      onDeleteOfficer(officerToDelete);
    }
    setIsDeleteModalOpen(false);
    setOfficerToDelete(null);
  };
  const cancelDelete = () => {
    setIsDeleteModalOpen(false);
    setOfficerToDelete(null);
  };

  const handleEditClick = (officer, index) => {
    setEditingOfficer({ ...officer, index });
    setIsModalOpen(true);
  };
  const isApproved =
    clearanceStatus === ClearanceStatus.PAID ||
    clearanceStatus === ClearanceStatus.CLEARANCE_REJECTED ||
    clearanceStatus === ClearanceStatus.CANCELLED ||
    clearanceStatus === ClearanceStatus.CORRECTION_REQUESTED;
  return (
    <div>
      <div className="escort-departure-officers-list">
        <div className="escort-officers-header">
          <p>Added Officers</p>
          {!isApproved && (
            <button
              className="escort-add-officer-btn"
              onClick={handleAddOfficeClick}
            >
              <AddIcon />
              Add Officer
            </button>
          )}
        </div>
        <div className="escort-officers-box">
          {officers.length > 0 ? (
            officers.map((officer, index) => (
              <div className="escort-officer" key={index}>
                <div className="escort-officer-details">
                  <p>
                    {officer.name} - {officer.hoursWorked} hrs
                  </p>
                </div>
                {!isApproved && (
                  <div className="escort-officer-actions">
                    <img
                      className="escort-edit-icon"
                      src={editIcon}
                      alt="edit icon"
                      onClick={() => handleEditClick(officer, index)}
                    />
                    {officers.length > 2 && (
                      <img
                        className="escort-delete-icon"
                        src={deleteIcon}
                        alt="delete icon"
                        onClick={() => handleDeleteClick(index)}
                      />
                    )}
                  </div>
                )}
              </div>
            ))
          ) : (
            <p className="no-officers-message">No officers added</p>
          )}
        </div>
      </div>
      <Modal
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          setEditingOfficer(null);
        }}
      >
        <AddOfficerModal
          cfpPhase={TRIP_PHASE.DEPARTURE}
          onAddOfficer={(updatedOfficer) => {
            if (editingOfficer) {
              onEditOfficer(editingOfficer.index, updatedOfficer[0]);
            } else {
              onAddOfficer(updatedOfficer);
            }
          }}
          onClose={() => {
            setIsModalOpen(false);
            setEditingOfficer(null);
          }}
          airportId={airportId}
          existingOfficers={officers.filter((_, i) =>
            editingOfficer ? i !== editingOfficer.index : true
          )}
          editingOfficer={editingOfficer}
        />
      </Modal>
      <DeleteModal
        isOpen={isDeleteModalOpen}
        onClose={cancelDelete}
        onDelete={confirmDeleteOfficer}
      />
    </div>
  );
};

export default EscortDepartureOfficersList;
